module.exports = __webpack_public_path__ + "media/giftcards/EGiftCardConfirmation-83e56dd9.png";